import MuiInput from '@material-ui/core/Input';
import { CKButton } from 'clearkit';

import Close from './Close.svg';
import styles from './styles';

const Scores = ({ classes, selectedScore, onSelectScore }) => {
  let scores = [];

  for (let i = 1; i <= 10; i++) {
    scores.push(
      <button
        className={classnames(classes.scoreOption, {
          [classes.selectedScoreOption]: selectedScore === i,
        })}
        key={`score-${i}`}
        onClick={() => onSelectScore(i)}
      >
        {i}
      </button>,
    );
  }

  return (
    <div
      className={classnames(classes.scores, {
        [classes.surveyExpanded]: selectedScore !== undefined,
      })}
    >
      {scores}
    </div>
  );
};

const Comment = ({ onSubmit, classes }) => {
  const [inputValue, setInputValue] = useState();

  const onClickSubmit = () => onSubmit(inputValue);

  return (
    <>
      <div className={classes.surveyQuestion}>
        Why did you choose that score?
      </div>
      <MuiInput
        autoFocus
        className={classes.input}
        fullWidth
        multiline
        onChange={(e) => setInputValue(e.target.value)}
        placeholder="Let us know what's working well and what could be improved"
        rows="5"
      />
      <div style={{ textAlign: 'right' }}>
        <CKButton onClick={onClickSubmit} variant="bold" variantColor="blue">
          Submit feedback
        </CKButton>
      </div>
    </>
  );
};

const SuccessMessage = ({ onDismiss, classes, score }) => {
  return (
    <div>
      <div className={classes.successScore}>{score}</div>
      <div className={classes.successMessageText}>
        Thank you for taking a moment to let us know your thoughts on Clearbit
        X!
      </div>
      <div style={{ textAlign: 'center' }}>
        <CKButton onClick={onDismiss} variant="secondary">
          Dismiss
        </CKButton>
      </div>
    </div>
  );
};

const NPS = ({
  classes,
  onClose,
  onSelectScore: onSelectScoreProp,
  onSubmitComment: onSubmitCommentProp,
}) => {
  const [selectedScore, setSelectedScore] = useState();
  const [submitted, setSubmitted] = useState(false);

  const onSubmitComment = (value) => {
    setSubmitted(true);
    onSubmitCommentProp(value);
  };

  const onSelectScore = (score) => {
    setSelectedScore(score);
    onSelectScoreProp(score);
  };

  return (
    <div className={classes.container}>
      {!submitted && (
        <>
          <div
            className={classnames(classes.headline, {
              [classes.headlineGray]: selectedScore !== undefined,
            })}
          >
            How likely are you to recommend Clearbit to a colleague?
          </div>
          <a
            className={classes.close}
            onClick={onClose}
            role="button"
            tabIndex={0}
          >
            <Close />
          </a>
          <Scores
            classes={classes}
            onSelectScore={onSelectScore}
            selectedScore={selectedScore}
          />
        </>
      )}
      {selectedScore !== undefined && !submitted && (
        <Comment classes={classes} onSubmit={onSubmitComment} />
      )}
      {submitted && (
        <SuccessMessage
          classes={classes}
          onDismiss={onClose}
          score={selectedScore}
        />
      )}
    </div>
  );
};

NPS.propTypes = {
  classes: PropTypes.shape({}),
  onClose: PropTypes.func,
  onSelectScore: PropTypes.func,
  onSubmitComment: PropTypes.func,
};

export default withStyles(styles)(NPS);
